import type { ThemeOptions } from "@mui/material/styles";
import colors from "./palette.json";


export default {
	palette: {
		mode: "light",
		background: {
			header: "linear-gradient(0deg, #2c2e69 -44.07%, #575bcf 152.54%)",
			default: colors.grey["200"],
			sidebar: colors.white
		},
		primary: {
			contrastText: colors.white,
			main: "rgba(32, 31, 32, 1)",
			dark: "rgba(32,31,32,.84)",
			light: "rgba(32,31,32,.54)"
		},
		text: {
			primary: colors.black,
			secondary: colors.grey["600"],
			light: colors.white
		},
		alert: {
			error: {
				background: colors.red["100"],
				border: colors.red["600"],
				icon: colors.red["500"],
				text: colors.white
			}
		},
		article: {
			shadow: "rgba(0, 0, 0, 0.36)"
		},
		pagination: {
			label: colors.grey["500"]
		}
	},
	components: {
		MuiCssBaseline: {
			styleOverrides: {
				"*": {
					boxSizing: "border-box"
				},
				body: {
					height: "100%"
				}
			}
		}
	}
} as ThemeOptions;